module.exports = __webpack_public_path__ + "img/EMT-BRCA_her2st.dbe4bb8b.png";